import React from 'react';
import { Link } from 'react-router-dom';
import CampusLife from './CampusLife';
import principalImg from '../assets/images/Principal.jpeg';
import superintendentImg from '../assets/images/superintendent.jpeg';
import heroImage from '../assets/images/hero.jpeg';
import hero2Image from '../assets/images/Hero2.jpeg';
import collegeLogo from '../assets/images/logo_clg.webp';
import departmentData from './departmentData';
import { Helmet } from 'react-helmet-async';
import { SITE_URL } from '../config/site';

function Home() {
  return (
    <main>
      <Helmet>
        <title>ACSR Government Medical College, Nellore | Official Website</title>
        <meta name="description" content="A.C.S.R Government Medical College, Nellore. MBBS program, departments, committees, campus life, and academic information." />
        <meta name="keywords" content="ACSR, Government Medical College, Nellore, MBBS, Departments, Medical Education" />
        <link rel="canonical" href={`${SITE_URL}/`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="ACSR Government Medical College, Nellore" />
        <meta property="og:description" content="Official website of A.C.S.R Government Medical College, Nellore." />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta name="twitter:card" content="summary" />
      </Helmet>
      {/* Hero Section */}
      <section className="hero-section" style={{backgroundImage: `url(${heroImage})`}}>
        <div className="hero-overlay"></div>
        <div className="container position-relative">
          <div className="row align-items-center">
            <div className="col-lg-10 col-xl-8 mx-auto text-center text-white">
              <img src={collegeLogo} alt="ACSR Logo" className="hero-logo mb-3" height="100" />
              <h1 className="hero-title">A.C.S.R Government Medical College</h1>
              <p className="lead hero-subtitle">Nellore, Andhra Pradesh • Est. 2014</p>
              
              <div className="row mt-4 key-stats justify-content-center">
                <div className="col-md-4 mb-3 mb-md-0">
                  <div className="stat-item">
                    <div className="stat-number">175</div>
                    <div className="stat-label">MBBS Seats</div>
                  </div>
                </div>
                <div className="col-md-4 mb-3 mb-md-0">
                  <div className="stat-item">
                    <div className="stat-number">67.5</div>
                    <div className="stat-label">Acres Campus</div>
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="stat-item">
                    <div className="stat-number">2014</div>
                    <div className="stat-label">Established</div>
                  </div>
                </div>
              </div>
              
              <div className="hero-buttons mt-4">
                <Link to="/about" className="btn btn-primary me-3">About Us</Link>
                <Link to="/academics" className="btn btn-outline-light">Programs</Link>
              </div>
            </div>
          </div>
        </div>
      </section>
     
           {/* Departments */}
           <section className="py-5" style={{backgroundColor: '#2E3192'}}>
        <div className="container">
          <h2 className="text-center text-white mb-5" style={{fontSize: '2.5rem', letterSpacing: '1px', fontWeight: '700'}}>OUR DEPARTMENTS</h2>
          
          <div className="row g-4">
            {[
              'anaesthesiology', 'anatomy', 'biochemistry', 'community-medicine', 'dentistry', 'dvl',
              'forensic-medicine', 'emergency-medicine', 'ent', 'general-medicine',
              'hospital-administration', 'mch-neuro-surgery', 'mch-surgical-oncology', 'opthalmology',
              'microbiology', 'neurology', 'obstetrics-gynaecology', 'orthopedics', 'paediatrics',
              'pathology', 'pharmacology', 'physiology', 'psychiatry', 'pulmonoary-medicine',
              'radio-diagnosis', 'radation-oncology', 'transfusion-medicine', 'urology'
            ].map((dept, idx) => (
              <div className="col-6 col-md-4 col-lg-2" key={dept}>
                <Link to={`/departments/${dept}`} style={{textDecoration: 'none'}}>
                  <div className="dept-item bg-white rounded-3 text-center p-4 h-100 shadow-sm" style={{transition: 'all 0.3s ease'}}>
                    <div className="dept-icon mb-3 mx-auto d-flex align-items-center justify-content-center rounded-circle" 
                      style={{width: '70px', height: '70px', backgroundColor: 'rgba(46, 49, 146, 0.1)', transition: 'all 0.3s ease'}}>
                      {/* Optionally, you can add icons here based on dept if desired */}
                      <i className="fas fa-university fa-lg" style={{color: '#2E3192'}}></i>
                    </div>
                    <h5 className="fw-bold" style={{color: '#2E3192', fontSize: '0.9rem'}}>{dept.replace(/-/g, ' ').toUpperCase()}</h5>
                    <p className="text-muted small mb-0">{departmentData[dept]?.summary || 'Department information coming soon.'}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      {/* Welcome Section */}
      <section id="welcome-section">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-5 mb-lg-0">
              <h2 className="section-title">Welcome to A.C.SUBBA REDDY GOVERNMENT MEDICAL COLLEGE</h2>
              <p className="lead mb-4" style={{color: '#555'}}>Nurturing excellence in healthcare education since 2014</p>
              <p>The DSR District Headquarters Hospital, Nellore was built during 1963 - 1968. Foundation Stone was laid by the Honourable Chief Minister of Andhra Pradesh Sri Neelam Sanjeeva Reddy. It was inaugurated on 18 December 1968 by the Chief Minister of Karnataka Sri Veerendra Patil and presided by the Honourable Chief Minister of Andhra Pradesh, Sri Kasu Brahmananda Reddy.</p>
              <p>In 2014, the Government of Andhra Pradesh established the A.C. Subba Reddy Government Medical College, named after Anam Chenchu Subba Reddy, a veteran leader and former Municipal Chairman of Nellore district. The college is affiliated to Dr. NTR University of Health Sciences with an intake capacity of 175 MBBS seats per year.</p>
              <div className="mt-4">
                <Link to="/about" className="btn btn-primary me-3">Read More</Link>
                <Link to="/academics" className="btn btn-outline-primary">Our Programs</Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="position-relative">
                <div className="bg-light rounded-lg shadow overflow-hidden" style={{height: "350px"}}>
                  <img src={hero2Image} alt="College Building" className="img-fluid w-100 h-100" style={{objectFit: "cover"}} />
                </div>
                <div className="position-absolute" style={{bottom: '-15px', right: '-15px', width: '120px', height: '120px', backgroundColor: 'var(--primary-color)', opacity: '0.1', borderRadius: '50%', zIndex: '-1'}}></div>
                <div className="position-absolute" style={{top: '-15px', left: '-15px', width: '80px', height: '80px', backgroundColor: 'var(--primary-color)', opacity: '0.1', borderRadius: '50%', zIndex: '-1'}}></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision and Mission */}
      <section className="bg-light">
        <div className="container">
          <h2 className="section-title text-center mb-5">Our Vision & Mission</h2>
          <div className="row">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="card h-100 border-0 shadow-sm hover-card">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-4">
                    <span className="icon-circle bg-primary-light me-3">
                      <i className="fas fa-lightbulb text-primary"></i>
                    </span>
                    <h3 className="card-title mb-0">Our Vision</h3>
                  </div>
                  <p className="card-text">The future is embodied in the present generation. Professional education combined with practical exposure to create values in the students and employees who are the future of our nation.</p>
                  <div className="text-primary mt-4 icon-hover">
                    <i className="fas fa-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card h-100 border-0 shadow-sm hover-card">
                <div className="card-body">
                  <div className="d-flex align-items-center mb-4">
                    <span className="icon-circle bg-primary-light me-3">
                      <i className="fas fa-bullseye text-primary"></i>
                    </span>
                    <h3 className="card-title mb-0">Our Mission</h3>
                  </div>
                  <p className="card-text">Work oriented education and employment support with ethical values, character building in context of today's millennium.</p>
                  <div className="text-primary mt-4 icon-hover">
                    <i className="fas fa-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Campus Life Section */}
      <CampusLife />



      {/* Leadership Section */}
      <section className="leadership-section">
        <div className="container">
          <h2 className="text-center section-title mx-auto mb-5">Our Leadership</h2>
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card text-center border-0 shadow-sm leadership-card">
                <div className="card-body p-4">
                  <div className="leadership-avatar mb-4 mx-auto">
                    <img 
                      src={principalImg} 
                      alt="Dr. G. Rajeswari" 
                      className="rounded-circle"
                    />
                  </div>
                  <h4 className="card-title">Dr. G. Rajeswari</h4>
                  <p className="text-muted mb-3">Principal and Additional DME</p>
                  <hr className="my-3" />
                  <p className="card-text small">"Committed to excellence in medical education and healthcare"</p>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card text-center border-0 shadow-sm leadership-card">
                <div className="card-body p-4">
                  <div className="leadership-avatar mb-4 mx-auto">
                    <img 
                      src={superintendentImg} 
                      alt="Dr. K. Madhavi" 
                      className="rounded-circle"
                    />
                  </div>
                  <h4 className="card-title">Dr. K. Madhavi</h4>
                  <p className="text-muted mb-3">Superintendent</p>
                  <hr className="my-3" />
                  <p className="card-text small">"Ensuring the highest standards of medical care and hospital administration"</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home; 